<template>
  <div class="grid-settings">
    <i :id="settingsName" class="open-grid-settings-popover fa fa-cog fa-fw"></i>

    <b-popover
      ref="gridSettingsPopover"
      :target="settingsName"
      triggers="click blur"
      placement="bottomright"
    >
      <template slot="title">
        <div class="d-flex justify-content-between">
          <a>Columns</a>
          <i 
            @click="closeGridSettingsPopover"
            class="close-grid-settings-popover fa fa-times"
          ></i>
        </div>
      </template>
      
      <draggable v-model="fieldsLocal" handle=".grid-settings-handle">
        <transition-group name="flip-list">
          <div v-for="field in fieldsLocal" :key="field.key" class="d-flex align-items-center">
            <b-form-checkbox
              v-model="field.hidden"
              :value="false"
              :unchecked-value="true"
              :disabled="checkDisabledColumn(field)"
              :class="{ 'd-none': field.key === 'commands' }"
              @input="handleColumnVisibilityChange"
            >
              {{ field.label }}
            </b-form-checkbox>

            <i v-if="field.key !== 'commands'" class="fa fa-align-justify grid-settings-handle"></i>
          </div>
        </transition-group>
      </draggable>
    </b-popover>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import Draggable from 'vuedraggable';

export default {
  components: {
    Draggable,
  },
  props: {
    gridId: {
      type: String,
      default: '',
    },
    fields: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      fieldsLocal: this.fields.map(field => ({ ...field }) ),
    }
  },
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    // columns() {
    //   return this.gridSettings.columns || this.fieldsLocal;
    // },
    visibleColumnsCount() {
      return this.fieldsLocal.filter(field => !field.hidden).length;
    },
    settingsName(){
      return this.gridId + '-settings-trigger'; //used to uniquely define the settings target for the grid
    },
  },
  methods: {
    ...mapActions('account', ['saveGridSettings']),
    handleColumnVisibilityChange() {
      //this.$emit('update:fields', this.fieldsLocal);

      // this.saveGridSettings({
      //   id: this.gridId,
      //   settings: { columns: this.columns },
      // });
    },
    checkDisabledColumn({ field, hidden }) {
      // Disable columns visibility filter if there is only 1 visible column
      if (this.visibleColumnsCount === 1 && !hidden) {
        return true;
      }

      // Disable turning of the actions
      if (field === 'commands') {
        return true;
      }

      return false;
    },
    closeGridSettingsPopover() {
      this.$refs.gridSettingsPopover.$emit('close');
    },
  },
  watch: {
    fieldsLocal() {
      this.$emit('update:fields', this.fieldsLocal);
    },
  },
  created() {
    this.fieldsLocal.forEach((field, index) => {
      if(!field.hasOwnProperty('hidden')) {
        this.$set(this.fieldsLocal[index], 'hidden', false);
        //this.fieldsLocal[index].hidden = false; // Explicitly Set values to hidden = false if property doesn't exist
      }
    });

    //this.fieldsLocal = this.fieldsLocal.filter(field => field.key !== 'commands');
  },
};
</script>

<style lang="scss">
 .open-grid-settings-popover, .close-grid-settings-popover {
   cursor: pointer;
 }

.open-grid-settings-popover:hover, .close-grid-settings-popover:hover {
  opacity: 0.7;
}

.grid-settings {
  display: inline-block;
}

.grid-settings-handle {
  margin-left: 0.5rem;
  cursor: move;
}

.flip-list-move {
  transition: transform 0.5s;
}
</style>
